module.exports = __webpack_public_path__ + "img/background.c9361b86.svg";